<template>
  <div class="events">
    <el-main>
      <el-row class="nofull">
        <div class="row_header">
          <div class="row_title fl">会议活动</div>
          <div class="showSearch_btn">
            <el-button
              size="small"
              type="primary"
              icon="el-icon-s-operation"
              @click="showSearch = !showSearch"
              >筛选</el-button
            >
          </div>
          <div v-show="showSearch" class="row_inside fr mobileShow">
            <div class="sec_row">
              <span class="timepicker_label">时间范围</span>
              <el-date-picker
                size="small"
                v-model="start_time"
                type="date"
                placeholder="选择日期"
                :picker-options="pickerOptions0"
              >
              </el-date-picker>
              <span style="display: inline-block; padding: 0 5px"> - </span>
              <el-date-picker
                size="small"
                style="margin-left: 0"
                v-model="end_time"
                type="date"
                placeholder="选择日期"
                :picker-options="pickerOptions1"
              >
              </el-date-picker>
            </div>
            <div class="sec_row">
              <el-input
                v-model="keyword"
                size="small"
                placeholder="请输入关键词"
              ></el-input>
              <el-button type="primary" size="small" plain @click="handleSearch"
                >搜索</el-button
              >
            </div>
          </div>
          <!-- 以下div 是浏览器宽度768px以上显示 -->
          <div class="row_inside fr pcShow">
            <div class="sec_row">
              <span class="timepicker_label">时间范围</span>
              <el-date-picker
                size="small"
                v-model="start_time"
                type="date"
                placeholder="选择日期"
                :picker-options="pickerOptions0"
              >
              </el-date-picker>
              <span style="display: inline-block; padding: 0 5px"> - </span>
              <el-date-picker
                size="small"
                style="margin-left: 0"
                v-model="end_time"
                type="date"
                placeholder="选择日期"
                :picker-options="pickerOptions1"
              >
              </el-date-picker>
            </div>
            <div class="sec_row">
              <el-input
                v-model="keyword"
                size="small"
                placeholder="请输入关键词"
              ></el-input>
              <el-button type="primary" size="small" plain @click="handleSearch"
                >搜索</el-button
              >
            </div>
          </div>
          <div style="clear: both; height: 0; overflow: hidden"></div>
        </div>
        <el-row :gutter="40">
          <el-col :span="6" v-for="(item, index) in eventList" :key="index">
            <el-card :body-style="{ padding: '0px' }">
              <div class="card_state">
                <div :style="{ background: item.signUpStateColor }">
                  {{ item.signUpState }}
                </div>
                <div :style="{ background: item.submitStateColor }">
                  {{ item.submitState }}
                </div>
              </div>
              <router-link
                :to="{
                  path: '/eventDetail',
                  query: { eventId: item.forum_id },
                }"
              >
                <el-image
                  :src="
                    '/forum-pub-api/v1/minio/getFile?file_url=' + item.image_url
                  "
                  fit="cover"
                >
                  <div slot="error" class="image-slot">
                    <div class="errText">{{ item.name }}</div>
                    <img
                      class="el-image__inner"
                      style="object-fit: cover"
                      src="../assets/errbg.jpg"
                    />
                  </div>
                </el-image>
              </router-link>
              <div class="card_content">
                <!-- router-link可以像href一样跳转，query带id -->
                <router-link
                  class="card_title"
                  :to="{
                    path: '/eventDetail',
                    query: { eventId: item.forum_id },
                  }"
                >
                  {{ item.name }}
                </router-link>
                <!-- <div class="abstract">{{ item.description }}</div> -->
                <div class="card_org">
                  {{ orgLabel }}：<span>{{ item.setting_json.orgnizer }}</span>
                </div>
                <div class="time">
                  承办单位：<span>{{ item.setting_json.undertaker }}</span>
                </div>
                <time class="time"
                  >{{ sDate }}：<span>{{
                    changetoLocaleString(item.start_time)
                  }}</span></time
                >
                <time class="time"
                  >{{ eDate }}：<span>{{
                    changetoLocaleString(item.end_time)
                  }}</span></time
                >
                <div class="card_org">
                  举办城市: <span>{{ item.setting_json.city }}</span>
                </div>
                <div class="card_org">
                  举办地点: <span>{{ item.setting_json.address }}</span>
                </div>
                <!--
                                <div class="bottom clearfix" v-for="(obj, index) in [toJson(item.setting_json)]" :key="index">
                                    <div class="card_org">{{ orgLabel }}：<span>{{obj.orgnizer}}</span></div>
                                    <time class="time">{{ sDate }}：<span>{{ item.start_time }}</span></time>
                                    <time class="time">{{ eDate }}：<span>{{ item.end_time }}</span></time>
                                </div>
                                -->
              </div>
            </el-card>
          </el-col>
        </el-row>
        <el-pagination
          :page-size="pageSize"
          style="margin-top: 20px"
          background
          layout="prev, pager, next"
          :current-page="currentPage"
          @current-change="currentChange"
          :total="total"
        >
        </el-pagination>
      </el-row>
    </el-main>
  </div>
</template>

<script>
import { getEvents } from '@/apis/events.js';
export default {
  name: 'Events',
  created() {
    this.$emit('activeIndex', '2');
    this.$emit('pageClass', 'events');
    let currentPage = this.$route.query.page;
    this.currentPage = Number(currentPage);
    this.getEventList();
  },
  data() {
    return {
      showSearch: '',
      pageclass: 'events',
      pagetitle: '会议活动',
      start_time: '', // 搜索起始日期
      // 起始日期选择器时间范围限制
      pickerOptions0: {
        disabledDate: (date) => {
          if (this.end_time !== '' && this.end_time !== null) {
            return date.getTime() > this.end_time;
          } else {
            return date.getTime() === Date.now();
          }
        },
      },
      end_time: '', // 搜索结束日期
      // 结束日期选择器时间范围限制
      pickerOptions1: {
        disabledDate: (date) => {
          if (this.start_time !== '' && this.start_time !== null) {
            return date.getTime() < this.start_time;
          } else {
            return date.getTime() < Date.now();
          }
        },
      },
      keyword: '',
      orgLabel: '主办单位',
      sDate: '开始时间',
      eDate: '结束时间',
      total: null,
      currentPage: 1,
      pageSize: 12,
      eventList: [
        /*{
                        eventImgUrl: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
                        eventTitle:'北京经济论坛2020',
                        abstract: '北京经济论坛简介北京经济论坛简介北京经济论坛简介北京经济论坛北京经济论坛',
                        orgName: '中国经济学年会',
                        startDate: '2020–06-18 @ 08:00',
                        endDate: '2020–06-28 @ 08:00',
                        stateNum: '1',
                        signUpState: '',
                        signUpStateColor: '',
                        submitState: '投稿中',
                        submitStateColor: '#67c23a',
                    },*/
      ],
    };
  },
  methods: {
    changetoLocaleString(str) {
      if (str) {
        // let localeTime = new Date(str);
        // return this.common.dateFormat("YYYY/mm/dd", localeTime)
        return this.$moment(str).format('YYYY-MM-DD');
      } else {
        return str;
      }
    },
    handleSearch() {
      this.currentPage = 1;
      this.$router.push({ path: '/events', query: { page: 1 } });
      this.getEventList();
    },
    getEventList() {
      getEvents({
        sort_order: 'desc',
        page: this.currentPage,
        page_size: this.pageSize,
        start_time: this.start_time,
        end_time: this.end_time,
        keyword: this.keyword,
      })
        .then((res) => {
          if (res.status === 200) {
            if (res.data.success === true) {
              this.eventList = res.data.data.items;
              this.total = res.data.data.total;
            } else {
              this.$message.error(res.data.message);
            }
            console.log(res.data);
          } else {
            this.$message.error('未请求成功');
            console.log('错误');
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    toJson(str) {
      let jsonToObj = JSON.parse(str);
      // console.log(jsonToObj);
      return jsonToObj;
    },
    currentChange(val) {
      this.currentPage = val;
      console.log(this.currentPage);
      this.$router.push({ path: '/events', query: { page: this.currentPage } });
      this.getEventList();
    },
  },
};
</script>

<style scoped></style>
